import { ERROR_CODE, API_ERROR, ERRORPOPUP_NAVIGATION_TO_BACK } from '../../constants';
export function setApiError(payload) {
    return {
        type: API_ERROR,
        payload,
    };
}
export function setErrorCode(errorCode) {
    return {
        type: ERROR_CODE,
        errorCode: errorCode,
    };
}
export function setOnFromGoBackScreen(isFromGoBack) {
    return {
        type: ERRORPOPUP_NAVIGATION_TO_BACK,
        isFromGoBack,
    };
}
